import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function HeroSection() {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/singup");
  };
  return (
    <Container fluid className="text-center my-5 px-4" style={{ zIndex: 0 }}>
      <Row>
        <Col xs={12} md={10} lg={8} className="mx-auto">
          <h1 className="fw-bold mt-4 fs-1 fs-md-2 fs-lg-3">
            Streamline Business Payments
            <br className="d-none d-md-block" />
            with Connected Banking
          </h1>

          <p className="text-muted mt-4 fs-5">
            Simplify your finances and stay on top of cashflow with MyPe.
            Connect bank accounts
            <br className="d-none d-lg-block" />
            to pay vendors, receive payments, and reconcile effortlessly.
          </p>
          <Button
            onClick={handleRedirect}
            variant="primary"
            size="lg"
            className="px-4 py-3 fw-bold"
            style={{
              borderRadius: "50px",
              color: "#fcf9f9",
              background: "#752abf",
              fontSize: "1.1rem",
              border: "none",
              marginTop: "25px",
            }}
          >
           
            Get Started for Free
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default HeroSection;
